import { createTheme } from '@mui/material';

// ─── MUI Theme (TailAdmin-inspired with Terra17 purple brand) ──────────────

const theme = createTheme({
  palette: {
    primary: {
      main: '#6B3FA0',
      light: '#8B5FBF',
      dark: '#4A2D6E',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#465FFF',
      light: '#6B7FFF',
      dark: '#3347CC',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#F04438',
    },
    warning: {
      main: '#F79009',
    },
    success: {
      main: '#12B76A',
    },
    info: {
      main: '#0BA5EC',
    },
    background: {
      default: '#F8FAFC',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1E293B',
      secondary: '#64748B',
    },
    divider: '#E2E8F0',
  },
  typography: {
    fontFamily: "'Outfit', 'Helvetica', 'Arial', sans-serif",
    h1: {
      fontWeight: 600,
      fontSize: '2rem',
      '@media (min-width:900px)': { fontSize: '2.5rem' },
    },
    h2: {
      fontWeight: 600,
      fontSize: '1.75rem',
      '@media (min-width:900px)': { fontSize: '2rem' },
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.5rem',
      '@media (min-width:900px)': { fontSize: '1.75rem' },
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.25rem',
      '@media (min-width:900px)': { fontSize: '1.5rem' },
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.1rem',
      '@media (min-width:900px)': { fontSize: '1.25rem' },
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
      '@media (min-width:900px)': { fontSize: '1.1rem' },
    },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 500 },
    body1: { fontWeight: 400 },
    body2: { fontWeight: 400 },
    button: { fontWeight: 500 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none' as const,
          fontWeight: 500,
          boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: '1px solid #E2E8F0',
          boxShadow: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: '1px solid #E2E8F0',
          boxShadow: 'none',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            fontWeight: 600,
            backgroundColor: '#F8FAFC',
            color: '#1E293B',
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#F8FAFC',
        },
      },
    },
  },
});

export default theme;
